<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  gradient?: string;
}>();

const computedStrokeColor = computed(() => {
  return props.gradient ? "#FFFFFF" : "#61686E";
});

const computedGradient = computed(() => {
  return props.gradient || "transparent";
});

</script>

<template>
  <div class="v-responsive v-img relative rounded-full overflow-hidden" style="background-color: #DBDFE1;">
    <span 
      class="absolute inset-0 opacity-70 block"
      :style="{ backgroundImage: computedGradient }"
    ></span>
    <svg 
      width="150" 
      height="130" 
      class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full p-0.5 rounded-full"
      viewBox="0 0 150 130" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      >
        <g opacity="0.8">
          <path d="M76.7279 8.94384L71.1244 34.9382L64.2022 27.9937L53.7651 39.7639" :stroke="computedStrokeColor" stroke-width="1.3"/>
          <path d="M0.999941 90.5L15.5264 67.3722L41.3971 42.8322L64.1423 28.1413L76.7869 8.87983L79.6408 28.7549L83.4739 33.6714L119.129 0.950513L89.7834 39.2335L95.791 44.7374L108.208 61.3493L131.837 86.3824L132.503 95.1799L126.537 104.024L121.902 105.142L109.793 106.313L91.2503 93.0608L71.2516 86.9929L58.2774 85.2763L42.9999 137.5" :stroke="computedStrokeColor" stroke-width="1.3"/>
          <path d="M63.3089 86.7363L63.3096 86.7363L68.3015 87.3463L65.4719 95.1591L58.8693 86.1983L63.3089 86.7363Z" :stroke="computedStrokeColor" stroke-width="1.3"/>
          <path d="M48.9999 116.922L58.127 85.3555L65.4999 95.8555L56.9999 142.5" :stroke="computedStrokeColor" stroke-width="1.3"/>
          <path d="M58 85.8555L8.99994 107L56.7597 51.2848L58 85.8555Z" :stroke="computedStrokeColor" stroke-width="1.3"/>
          <path d="M121.903 105.084L98.6391 89.1515L91.3713 93.0013" :stroke="computedStrokeColor" stroke-width="1.3"/>
          <path d="M130.227 98.2835L99.1218 88.8933L71.4093 87.0245" :stroke="computedStrokeColor" stroke-width="1.3"/>
          <path d="M130.227 98.2835L128.763 88.5956L103.26 62.8322L98.2717 88.8951" :stroke="computedStrokeColor" stroke-width="1.3"/>
          <path d="M56.7707 51.4041L71.5382 86.5457L83.4678 49.8282L56.7707 51.4041Z" :stroke="computedStrokeColor" stroke-width="1.3"/>
          <path d="M108.328 61.4079L103.138 62.8012M103.138 62.8012L83.4976 49.8577L95.6691 44.6166C95.6691 44.6166 100.264 55.8289 103.138 62.8012Z" :stroke="computedStrokeColor" stroke-width="1.3"/>
          <path d="M83.4055 49.7069L71.1225 34.9628L79.5177 28.5728" :stroke="computedStrokeColor" stroke-width="1.3"/>
          <path d="M83.4447 33.6079L84.0183 37.9748L89.8454 39.2599" :stroke="computedStrokeColor" stroke-width="1.3"/>
          <path d="M83.3525 33.5214L87.2451 12.8296L79.7302 28.5732" :stroke="computedStrokeColor" stroke-width="1.3"/>
          <path d="M78.1176 17.945L87.2455 12.8461" :stroke="computedStrokeColor" stroke-width="1.3"/>
          <path d="M71.1837 34.8158L54.0961 39.6999L41.7279 42.7116" :stroke="computedStrokeColor" stroke-width="1.3"/>
          <path d="M54.0357 39.7884L56.981 51.2828L15.4373 67.7049" :stroke="computedStrokeColor" stroke-width="1.3"/>
      </g>
      <path opacity="0.8" d="M16.7061 66.8203L5.4766 100.746" :stroke="computedStrokeColor" stroke-width="1.3"/>
    </svg>
  </div> 
</template>
